import { createMutation } from '@/utils/common.js'
import { getSearchPermission } from '@/utils/api/permission-verification.js'
const store = {
  namespaced: true,
  state: () => {
    return {
      packages: null, // 套餐信息
    }
  },
  actions: {
  },
}

store.mutations = createMutation(store.state())

export default store
